import { cva } from 'class-variance-authority';

import s from './Modal.module.css';

export const modalVariants = cva(s.modal, {
  defaultVariants: {
    background: 'default',
  },
  variants: {
    background: {
      default: s['modal--background-default'],
      'gradient-accent': s['modal--background-gradient-accent'],
      'gradient-danger': s['modal--background-gradient-danger'],
    },
  },
});
